
import React, { Component } from "react";
import { FaCloud, FaServer , FaLaptop, FaUsers } from "react-icons/fa";
import Title from "./Title";



export default class Footer extends Component {
 state = {
    services: [
      {
        icon: <FaCloud/>,
        title: "Products",
        info:
          "Cloud calendars, Messaging platform, booking management tools "
      },
      {
        icon: <FaServer />,
        title: "Resources",
        info:
          "Blog"
      },
      {
        icon: <FaLaptop />,
        title: "How to contact us",
        info:
          "To get in touch with our dedicated support-team call 0780676133 or email saskiastudios@gmail.com"
      },
      {
        icon: <FaUsers />,
        title: "Customers",
        info:
          "customers"
      }
    ]
  };
 render() {
    return (
      <section className="services">
        <Title title="saskai studios" />
        <div className="services-center">
          {this.state.services.map(item => {
            return (
              <article key={`item-${item.title}`} className="service">
                <span>{item.icon}</span>
                <h6>{item.title}</h6>
                <p>{item.info}</p>
              
                
              </article>
              
            );
          })}
          
        </div>
        <br/>
          <hr/>
          <br/>
        <p>Saskia studios 2020 | Terms and conditions apply</p>
      </section>
    );
  }
}
